import { render, staticRenderFns } from "./SpecialHobby.vue?vue&type=template&id=9f3f248c&scoped=true&"
import script from "./SpecialHobby.vue?vue&type=script&lang=js&"
export * from "./SpecialHobby.vue?vue&type=script&lang=js&"
import style0 from "./SpecialHobby.vue?vue&type=style&index=0&id=9f3f248c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3f248c",
  null
  
)

export default component.exports